module.exports = __webpack_public_path__ + "img/120.57d90444.jpg";